// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__3IR1h","alertIcon":"ConfirmModal_alertIcon__1pDCC"};